import createVueApp from '@phoenix/createVueApp';
import SearchResults from '@maison/components/search/SearchResults.vue';
import SearchResultsNoResult from '@maison/components/search/SearchResultsNoResult.vue';

if (document.getElementById('phoenix-search-results')) {
  const app = createVueApp({}, true);
  app.component('SearchResults', SearchResults);
  app.mount('#phoenix-search-results');
}

if (document.getElementById('phoenix-search-results-no-result')) {
  const app = createVueApp({}, true);
  app.component('SearchResultsNoResult', SearchResultsNoResult);
  app.mount('#phoenix-search-results-no-result');
}
